import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var res;
export const addDepartmentTodo = createAsyncThunk('addDepartment', async (data) => {
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'department',
            data: {
                "name": data.department,
                "status": data.status,
                // "added_by": localStorage.getItem('userId')

            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('token') }
        })
        return res
    } catch (error) {
        return error?.response
    }
})




